import type { ComponentProps } from 'react'
import { cn } from '@dreamstack/util/src/cn'

const baseClass =
  'bg-accentroGray-full z-[-1] w-screen absolute left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] h-full'

type FullWidthBackgroundContainerProps = ComponentProps<'div'> & {
  backgroundColor?: string | null
}

export const FullWidthBackgroundContainer = ({
  backgroundColor,
  className,
  style,
  ...rest
}: FullWidthBackgroundContainerProps) => (
  <div
    className={cn(baseClass, className)}
    style={backgroundColor ? { ...style, backgroundColor } : style}
    {...rest}
  />
)
